import React from 'react';

import type { ViewProps } from 'react-native';

export const DatadogSessionReplayMask = ({ children }: React.PropsWithChildren<ViewProps>) => (
  <>{children}</>
);
